<template>
  <div class="main-wrapper container">
    <headerfive></headerfive>
    <!-- <layout-sidebar></layout-sidebar> -->

    <!-- Page Wrapper -->
    <div class="page-wrapper page-wrapper-four">
      <div class="content container-fluid">
        <indexpage></indexpage>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      mounted() {},
    };
  },
};
</script>
